import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0598be97")

_pushScopeId("data-v-0598be97")
const _hoisted_1 = { class: "exception-body access" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: "/assets/layout/images/logo-white.svg",
  alt: "usee-layout",
  class: "logo custome-img"
}, null, -1)
const _hoisted_3 = { class: "exception-content" }
const _hoisted_4 = { class: "exception-title" }
const _hoisted_5 = { class: "exception-detail" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("page.forbidden")), 1),
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("page.forbidden.messages")), 1),
      _createVNode(_component_router_link, { to: "/workspaces" }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("page.forbidden.action")), 1)
        ]),
        _: 1
      })
    ])
  ]))
})